"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { WorkspaceElementType } from '@integration-app/sdk';
import { useElement } from '../useElement.mjs';

function useAction(selector) {
  const {
    item: action,
    accessor,
    refresh,
    ...rest
  } = useElement(
    WorkspaceElementType.Action,
    selector,
    (integrationApp) => selector ? integrationApp.action(selector) : void 0
  );
  async function apply(integrationKeys) {
    const result = await accessor?.apply(integrationKeys);
    await refresh();
    return result;
  }
  async function reset() {
    await accessor?.reset();
    await refresh();
  }
  return { action, apply, reset, refresh, accessor, ...rest };
}

export { useAction };
